import routerOptions0 from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: false,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}